<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav>
  <router-view /> -->
  <div>
    <router-view />
  </div>
</template>
<script>
export default {

  data() {
    return {
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
  },
  mounted() {
    console.log("app vue",this.$route.query.id)
    if (this._isMobile()) {
      console.log("手机端");
      if (typeof this.$route.query.id == 'undefined') {
        // 未携带参数，默认为泰康云游之家
        console.log("手机端 undefined");
        this.$router.replace('/mobile').catch(err => {});
      } else {
        this.$router.replace({path:'/mobile',query:{id:this.$route.query.id}}).catch(err => {});
      }
    } else {
      console.log("pc端");
      if (typeof this.$route.query.id == 'undefined') {
        // 未携带参数，默认为泰康云游之家
        console.log("pc端 undefined");
        this.$router.replace('/pc').catch(err => {});
      } else {
        this.$router.replace({path:'/pc',query:{id:this.$route.query.id}}).catch(err => {});
      }
      //this.$router.replace({path:'/pc',query:{setid:111111}}).catch(err => {});
    } 
  }
}
</script>

<style lang="less">
  // .test-viewport {
  //   width: 750px;
  //   height: 100px;
  //   font-size: 40px;
  //   text-align: center;
  //   line-height: 100px;
  //   background: #13b5b1;
  // }
  ::-webkit-scrollbar {
    display: none;  /* Chrome,Safari */
}
  .imgouttop {
    height: 802px;
  /*   background: url('./assets/img/topimg.png'); */

    background-size: cover;

    .imgtop {
      width: 100%;
      height: 100%;
    }
  }

  // #app {
  //   font-family: Avenir, Helvetica, Arial, sans-serif;
  //   -webkit-font-smoothing: antialiased;
  //   -moz-osx-font-smoothing: grayscale;
  //   text-align: center;
  //   color: #2c3e50;
  // }

  // nav {
  //   padding: 30px;

  //   a {
  //     font-weight: bold;
  //     color: #2c3e50;

  //     &.router-link-exact-active {
  //       color: #42b983;
  //     }
  //   }
  // }
</style>
